<template>
  <div :class="{ 'health-bar': true, 'is-right': align === 'right' }">
    <div class="hearts">
      <div class="heart"></div>
      <div class="heart"></div>
      <div class="heart"></div>
      <div class="heart"></div>
      <div class="heart"></div>
    </div>
    <div class="name">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HealthBar',

  props: {
    align: {
      type: String,
      default: 'left'
    }
  }
}
</script>

<style lang="sass" scoped>
.health-bar
  position: relative
  &.is-right
    text-align: right
    .hearts
      justify-content: flex-end
    .heart
      margin-left: 2px
      margin-right: 0

.hearts
  display: flex
  margin-bottom: 2px

.heart
  width: 8px
  height: 8px
  background: #cbcbcb
  margin-right: 2px
</style>
